type ThemeProps = {
    darkMode: boolean;
    image: string;
    backgroundColor: string;
    backgroundImageUrl: string;
    useCustomImage: boolean;
};

export default class Theme {
    darkMode: boolean;

    image: string; /** Référence à l'image de thème (pour les thèmes prédéfinis) */

    backgroundColor: string;

    backgroundImageUrl: string;

    useCustomImage: boolean;

    constructor({
        darkMode,
        image,
        backgroundColor,
        backgroundImageUrl,
        useCustomImage,
    }: ThemeProps) {
        this.darkMode = darkMode;
        this.image = image;
        this.backgroundColor = backgroundColor;
        this.backgroundImageUrl = backgroundImageUrl;
        this.useCustomImage = useCustomImage;
    }
}
